import {
  Banner,
  BlockStack,
  Card,
  InlineStack,
  Spinner,
} from '@shopify/polaris';
import { HistoryHeroStats } from './HistoryHeroStats';
import { HistoryTable } from './HistoryTable';
import { HistoryEmptyState } from '../shared/EmptyStates';
import type { NotificationItem } from '@/queries/notifications';

export interface HistoryTabProps {
  notifications: NotificationItem[];
  isLoading: boolean;
  error: Error | null;
  onGotoCompose: () => void;
}

export function HistoryTab({
  notifications,
  isLoading,
  error,
  onGotoCompose,
}: HistoryTabProps) {
  if (isLoading) {
    return (
      <Card>
        <InlineStack align="center" blockAlign="center">
          <Spinner accessibilityLabel="loading" />
        </InlineStack>
      </Card>
    );
  }

  if (error) {
    return (
      <Banner tone="critical">
        <p>{error.message}</p>
      </Banner>
    );
  }

  if (!notifications.length) {
    return (
      <Card>
        <HistoryEmptyState onGotoCompose={onGotoCompose} />
      </Card>
    );
  }

  return (
    <BlockStack gap="400">
      <HistoryHeroStats notifications={notifications} />
      <Card padding="0">
        <HistoryTable notifications={notifications} />
      </Card>
    </BlockStack>
  );
}
